import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

const useCompaniesQuery = () => {
  return useSuspenseQuery({
    queryKey: api.tag.getActiveCompaniesKey(),
    queryFn: api.tag.getActiveCompanies,
  });
};

export default useCompaniesQuery;
